import { IRootState } from '../../../store'
import { IServiceConfig } from '../store/configurations.types'

export const getServiceConfigSelector = (state: IRootState): IServiceConfig => state.configurations.serviceConfig
